import React, { useState, useEffect } from 'react';
import './index.scss';
import DeliveryOTP from '../delivery-otp';

const SwipeCarousel = ({ orderStatus = [], theme }) => {
  const [startX, setStartX] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [filteredOrderStatus, setFilteredOrderStatus] = useState(
    Array.isArray(orderStatus)
      ? orderStatus.filter(statusData => statusData?.status !== 'PICKEDUP')
      : []
  );

  const [isDeliveredVisible, setIsDeliveredVisible] = useState(
    orderStatus.some(status => status?.status === 'PICKEDUP')
  );

  useEffect(() => {
    if (isDeliveredVisible) {
      const timer = setTimeout(() => {
        setFilteredOrderStatus(prev =>
          prev.filter(statusData => statusData?.status !== 'PICKEDUP')
        );
        setIsDeliveredVisible(false);
        setCurrentIndex(0);
      }, 60000);

      return () => clearTimeout(timer);
    }
  }, [isDeliveredVisible]);

  const handleTouchStart = e => {
    setStartX(e.touches[0].clientX);
    setIsSwiping(true);
  };

  const handleTouchMove = e => {
    if (!isSwiping) return;
  };

  const handleTouchEnd = e => {
    if (!isSwiping) return;

    const touchDeltaX = e.changedTouches[0].clientX - startX;

    if (touchDeltaX < -100 && currentIndex < filteredOrderStatus.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (touchDeltaX > 100 && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }

    setIsSwiping(false);
  };

  const handleStatusDisappear = status => {
    if (status === 'PICKEDUP') {
      setFilteredOrderStatus(prev =>
        prev.filter(item => item.status !== 'PICKEDUP')
      );
    }
  };

  if (filteredOrderStatus.length === 0 && !isDeliveredVisible) return null;

  return (
    <div className="swipe-order-status">
      <div
        className="swipe-order-status__container"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: 'transform 0.3s ease-out'
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {isDeliveredVisible && (
          <div className="swipe-order-status__slide">
            <DeliveryOTP
              data={{ status: 'PICKEDUP' }}
              theme={theme}
              onStatusDisappear={handleStatusDisappear}
            />
          </div>
        )}
        {filteredOrderStatus.map((statusData, index) => (
          <div className="swipe-order-status__slide" key={index}>
            <DeliveryOTP
              data={statusData}
              theme={theme}
              onStatusDisappear={handleStatusDisappear}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SwipeCarousel;
